import initialState from '../initialState';
import estimationChangeConfirmed from './estimationChangeConfirmed';
import EstimationState, { PlacingEstimationStatus } from '../State';
import Event from '../../core/Event';
import EstimationsRequestSucceed from '../events/EstimationsRequestSucceed';
import EstimationProductsSearchRequested from '../events/EstimationProductsSearchRequested';
import EstimationsDraftSaveSucceed from '../events/EstimationsDraftSaveSucceed';
import EstimationsPlaceSucceed from '../events/EstimationsPlaceSucceed';
import EstimationChangeConfirmed from '../events/EstimationChangeConfirmed';
import EstimationsImportSucceed from '../events/EstimationsImportSucceed';
import { addFilterToArray, removeFilterFromArray } from '../../core/arrayOperations';
import EstimationsFilterSelected from '../../order/events/EstimationsFilterSelected';
import EstimationsFilterRemoved from '../../order/events/EstimationsFilterRemoved';
import EstimationsPlaceFailed from '../events/EstimationsPlaceFailed';
import EstimationsPlaceRequestSent from '../events/EstimationsPlaceRequestSent';
import { parseEstimations } from './importFromExcel';

export default (state: EstimationState = initialState, anyEvent: Event): EstimationState => {
    switch (anyEvent.type) {
        case EstimationsFilterSelected.type: {
            return {
                ...state,
                filters: addFilterToArray(state.filters, (anyEvent as EstimationsFilterSelected).filter)
            };
        }
        case EstimationsFilterRemoved.type: {
            return {
                ...state,
                filters: removeFilterFromArray(state.filters, (anyEvent as EstimationsFilterRemoved).filter)
            };
        }
        case EstimationChangeConfirmed.type:
            return estimationChangeConfirmed(state, anyEvent as EstimationChangeConfirmed);
        case EstimationsRequestSucceed.type: {
            const event: EstimationsRequestSucceed = anyEvent as EstimationsRequestSucceed;
            return {
                ...state,
                estimations: event.savedDraftEstimations.length > 0 ? event.savedDraftEstimations : event.placedEstimations,
                savedDraftEstimations: event.savedDraftEstimations,
                placedEstimations: event.placedEstimations
            };
        }
        case EstimationProductsSearchRequested.type: {
            return {
                ...state,
                searchQuery: (anyEvent as EstimationProductsSearchRequested).query
            };
        }
        case EstimationsDraftSaveSucceed.type: {
            return {
                ...state,
                savedDraftEstimations: (anyEvent as EstimationsDraftSaveSucceed).estimations,
                placedEstimations: []
            };
        }
        case EstimationsPlaceRequestSent.type: {
            return {
                ...state,
                placingEstimationStatus: PlacingEstimationStatus.Progress
            };
        }
        case EstimationsPlaceSucceed.type: {
            return {
                ...state,
                placedEstimations: (anyEvent as EstimationsPlaceSucceed).estimations,
                savedDraftEstimations: [],
                placingEstimationStatus: PlacingEstimationStatus.Null
            };
        }
        case EstimationsPlaceFailed.type: {
            return {
                ...state,
                placingEstimationStatus: PlacingEstimationStatus.Null
            };
        }
        case EstimationsImportSucceed.type: {
            const event: EstimationsImportSucceed = anyEvent as EstimationsImportSucceed;
            return {
                ...state,
                estimations: parseEstimations(state.estimations, event.rowsToImport)
            };
        }
    }
    return state;
};



// WEBPACK FOOTER //
// ./src/application/estimations/reducer/reducer.ts